import { defineComponent as _defineComponent } from 'vue'
import { reactive, ref, watch } from "vue";
import Modal2Component from "@/components/modal/Modal2Component.vue";
import { getStatusSelectOptions } from "@/services/status";
import { getClientInstance } from "@/services/client/clientProvider";
import { CompanyEmployeeModel } from "@/services/types/employee";
import { getUserFio } from "@/services/utils";
import { showErrorMessage } from "@/services/ui/messages";
import { useCompanyUsersStore } from "@/pinia/subcompanies/companyUsers";
import { getRolesOptions } from "@/services/roles/utils";
import { getStore } from "@/store/getStore";
import { Storage } from "@/services/storage/Storage";

interface FormModel {
  newPassword: string;
  status: string;
  roles: string[];
}

interface Props {
  value: boolean;
  user?: CompanyEmployeeModel;
  companyId?: number;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'EditUserFormModal',
  props: {
    value: { type: Boolean },
    user: null,
    companyId: null
  },
  emits: ["input"],
  setup(__props: any, { emit }) {

const props = __props as {
  value: boolean;
  user?: CompanyEmployeeModel;
  companyId?: number;
}




function emitUpdateValue(newValue: boolean) {
  emit("input", newValue);
}

const isPending = ref(false);
const roleOptions = ref<{ text: string; value: string }[]>([]);
const statusOptions = getStatusSelectOptions();
const formModel = reactive<FormModel>({
  newPassword: "",
  status: "",
  roles: [],
});

watch(props, function (props: Props) {
  if (props.value && props.user) {
    formModel.newPassword = "";
    formModel.status = props.user.status;
    formModel.roles = props.user.roles;

    getClientInstance()
      .getAvailableUserRoles({
        forSubcompanyUsers: !!props.companyId,
      })
      .then((opts) => (roleOptions.value = getRolesOptions(opts)));
  }
});

async function handleSubmit() {
  isPending.value = true;
  try {
    const resp = await getClientInstance().updateUser({
      id: props.user.id,
      status: formModel.status,
      roles: formModel.roles,
      ...(formModel.newPassword.length && {
        newPassword: formModel.newPassword,
      }),
    });

    const currentUserId = getStore().getters.getAuthentificationProfile.id;
    if (currentUserId === props.user.id) {
      const newProfileData = await getClientInstance().getUserSelf();
      const mergedProfileData = Object.assign(
        getStore().getters.getAuthentificationProfile,
        newProfileData
      );
      const storage = new Storage();
      storage.profile.set(mergedProfileData);
    }

    emitUpdateValue(false);
    await useCompanyUsersStore().fetchUsers(useCompanyUsersStore().company?.id);
  } catch (e) {
    showErrorMessage(e);
  } finally {
    isPending.value = false;
  }
}

return { __sfc: true,props, emit, emitUpdateValue, isPending, roleOptions, statusOptions, formModel, handleSubmit, Modal2Component, getUserFio }
}

})